import React from 'react';
import { mockData } from '../data/mockData';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  return (
    <section className="relative py-32 bg-[#121212]">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="display-large text-white mb-6">
            Frequently Asked <span className="text-[#00FFD1]">Questions</span>
          </h2>
          <p className="body-large text-white/85 max-w-3xl mx-auto">
            Everything you need to know about our 360° virtual tour services.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {mockData.faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-white/5 backdrop-blur-sm border border-white/10 px-8 data-[state=open]:border-[#00FFD1]/50"
              >
                <AccordionTrigger className="text-white hover:text-[#00FFD1] heading-3 text-left py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-white/70 body-medium pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Still have questions CTA */}
        <div className="text-center mt-16">
          <p className="body-large text-white/70">
            Still have questions?{' '}
            <a href="#contact" className="text-[#00FFD1] hover:underline font-semibold">
              Contact us
            </a>{' '}
            – we're here to help!
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
